import { Routes, Route, Navigate } from 'react-router-dom';
import AuthModal from '@/components/auth/AuthModal';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import SelfRegisteredRoute from '@/components/common/SelfRegisteredRoute';

import { NotFoundPage } from '@/pages/NotFoundPage';
import GameLayout from './layouts/GameLayout';
import MainLayout from './layouts/MainLayout';
import {
  AccountStatementPage,
  ActivityLogsPage,
  AuthVerificationPage,
  CasinoResultsPage,
  ChangePasswordPage,
  BetHistoryPage,
  HomePage,
  LiveCasinoBetsPage,
  MarketsPage,
  SportsPage,
  TermsConditionsPage,
  CasinoPage,
  QTECHLobbyPage,
  CasinoPlaygroundPage,
  CasinoBetHistoryPage,
  DepositPage,
  BonusStatementPage,
  ProfilePage,
  RulesPage,
  OffersPage,
  TransactionReportPage,
  ReferralPage,
  WithdrawPage,
} from '@/routes';
import { ScrollToTop } from '@/utils/ScrollToTop';
import CasinoLayout from './layouts/CasinoLayout';
import SupportButton from '@/components/common/SupportButton';
import MaintenancePage from './pages/MaintenancePage';

export function App() {
  if (import.meta.env.VITE_MAINTENANCE_MODE === 'true') {
    return (
      <Routes>
        <Route path="*" element={<MaintenancePage />} />
      </Routes>
    );
  }

  return (
    <>
      <ScrollToTop />
      <SupportButton />
      <AuthModal />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/all-sports/:sportName" element={<SportsPage />} />
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/offers" element={<OffersPage />} />
          {/* <Route path="/user/casino-results" element={<CasinoResultsPage />} /> */}
          {/* <Route path="/user/live-casino-bets" element={<LiveCasinoBetsPage />} /> */}
          {/* Protected Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/user/account-statement" element={<AccountStatementPage />} />
            <Route path="/user/bet-history" element={<BetHistoryPage />} />
            <Route path="/user/activity-logs" element={<ActivityLogsPage />} />
            <Route path="/user/casino-bet-history" element={<CasinoBetHistoryPage />} />
            {/* <Route path="/user/secure-auth-verification" element={<AuthVerificationPage />} /> */}
            <Route path="/user/change-password" element={<ChangePasswordPage />} />
            <Route path="/user/bonus-statement" element={<BonusStatementPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/user/transactions" element={<TransactionReportPage />} />
            <Route element={<SelfRegisteredRoute />}>
              <Route path="/deposit" element={<DepositPage />} />
              <Route path="/referral" element={<ReferralPage />} />
              <Route path="/withdraw" element={<WithdrawPage />} />
            </Route>
          </Route>
        </Route>

        <Route element={<CasinoLayout />}>
          <Route path="/casino" element={<CasinoPage />} />
          <Route path="/casino-playground" element={<CasinoPlaygroundPage />} />
          <Route path="/casino-qtech" element={<QTECHLobbyPage />} />
        </Route>
        <Route element={<GameLayout />}>
          <Route path="/game-details/:sportName/:eventId" element={<MarketsPage />} />
        </Route>

        {/* 404 */}
        <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
